<div class="grid grid-cols-2 gap-2 items-start">
	@for (def of definitions(); track trackByFilterType($index, def)) {
		@let filterValue = uiStore.filterValueSignalFactory(def.type)();
		@let config = def.controlOptions;
		<div class="filter-item-wrapper col-span-2">
			<label [for]="def.type" class="block text-sm font-medium text-gray-700 mb-1">
				@if (def.icon) {
					<icon [icon]="def.icon" class="mr-1 text-gray-500" />
				}
				{{ def.labelKey | translate }}
			</label>
			@switch (def.controlType) {
				@case ('checkbox') {
					<label class="flex items-center space-x-2 rtl:space-x-reverse text-sm cursor-pointer mt-1">
						<input
							type="checkbox"
							[id]="def.type"
							[name]="def.type"
							class="rounded border-gray-300 text-blue-600 shadow-sm focus:ring-blue-500"
							[ngModel]="getCurrentBooleanValue(def.type)"
							[ngModelOptions]="{standalone: true}"
							(change)="onCheckboxChange(def, $event)"
						/>
						<span>{{ def.labelKey | translate }}</span>
					</label>
				}
				@case ('select') {
					@let selectConfig = config?.SELECT;
					@if (selectConfig.multi) {
						<p-multiSelect
							#MULTISELECT
							class="w-full"
							[styleClass]="`${config.styleClass}`"
							[options]="def.options()"
							[ngModel]="filterValue"
							(ngModelChange)="$event !== filterValue && onValueChange(def, $event)"
							[ngModelOptions]="{standalone: true}"
							[optionLabel]="selectConfig?.optionLabel || 'label'"
							[optionValue]="selectConfig?.optionValue || 'value'"
							[placeholder]="def?.placeholder || '' | translate"
							[filter]="selectConfig?.filter === true"
							[filterBy]="selectConfig?.filterBy || 'label'"
							[appendTo]="selectConfig?.appendTo || 'body'"
							[group]="selectConfig?.group"
							[showHeader]="false"
							[overlayOptions]="{styleClass: 'global-search-filter-dropdown', hideOnEscape: true}"
							(onPanelHide)="onSelectPanelHide()"
						>
							@if (selectConfig.group) {
								<ng-template let-group pTemplate="group">
									<div>{{ group?.label | translate }}</div>
								</ng-template>
								<ng-template pTemplate="selectedItems" let-options>
									@for (option of options; track option; let isLast = $last) {
										<span>{{ option?.label | translate }}</span>
										@if (!isLast) {
											<span class="mx-1">,</span>
										}
									}
								</ng-template>
								<ng-template pTemplate="item" let-option>
									<div class="flex items-center">
										@if (option.icon) {
											<icon [icon]="option.icon" class="mr-2 text-gray-500" />
										}
										<span>{{ option?.label | translate }}</span>
									</div>
								</ng-template>
							}
						</p-multiSelect>
					} @else {
						<p-dropdown
							[styleClass]="`${config.styleClass}`"
							[options]="def.options()"
							[ngModel]="filterValue"
							(ngModelChange)="$event !== filterValue && onValueChange(def, $event)"
							[ngModelOptions]="{standalone: true}"
							[optionLabel]="selectConfig?.optionLabel || 'label'"
							[optionValue]="selectConfig?.optionValue || 'value'"
							[placeholder]="def?.placeholder || '' | translate"
							[showClear]="selectConfig?.showClear === true"
							[filter]="selectConfig?.filter === true"
							[filterBy]="selectConfig?.filterBy || 'label'"
							[appendTo]="selectConfig?.appendTo || 'body'"
							[group]="selectConfig?.group"
							[overlayOptions]="{styleClass: 'global-search-filter-dropdown', hideOnEscape: true}"
							(onHide)="onSelectPanelHide()"
						>
							@if (selectConfig.group) {
								<ng-template let-group pTemplate="group">
									<div class="text-sm font-semibold text-gray-700">{{ group.label | translate }}</div>
								</ng-template>
							}
							<ng-template pTemplate="selectedItem" let-option>
								<span>{{ option.label | translate }}</span>
							</ng-template>
							<ng-template let-option pTemplate="item">
								<div class="flex items-center">
									@if (option.icon) {
										<icon [icon]="option.icon" class="mr-2 text-gray-500" />
									}
									<span>{{ option.label | translate }}</span>
								</div>
							</ng-template>
						</p-dropdown>
					}
				}
				@case ('date') {
					@let dateConfig = config?.DATE;
					<p-calendar
						#dateCal
						[ngModel]="filterValue"
						[inputId]="def.type"
						[name]="def.type"
						(ngModelChange)="onValueChange(def, $event)"
						[ngModelOptions]="{standalone: true}"
						[selectionMode]="dateConfig?.selectionMode || 'range'"
						[appendTo]="dateConfig?.appendTo || 'body'"
						[styleClass]="def.controlOptions?.styleClass || 'filter-item p-0'"
						[readonlyInput]="dateConfig?.readonlyInput === true"
						[placeholder]="def?.placeholder || '' | translate"
						[showIcon]="dateConfig?.showIcon === true"
						[dateFormat]="dateConfig?.dateFormat || 'dd/mm/yy'"
						[showClear]="dateConfig?.showClear === true"
						[maxDate]="$any(dateConfig?.maxDate) || today"
						[minDate]="$any(dateConfig?.minDate) || null"
						[panelStyleClass]="'global-search-filter-dropdown'"
					/>
				}
				@case ('text') {
					<input
						type="text"
						[id]="def.type"
						[name]="def.type"
						[placeholder]="def.placeholder | translate"
						class="filter-item"
						[ngModel]="filterValue"
						[ngModelOptions]="{standalone: true}"
						(ngModelChange)="onValueChange(def, $event)"
					/>
				}
				@default {
					<p class="text-xs text-red-500 italic">סוג פילטר לא נתמך: {{ def.type }}</p>
					>
				}
			}
		</div>
	} @empty {
		<p class="text-sm text-gray-500 italic col-span-full">אין פילטרים להצגה.</p>
	}
</div>
